import CustomReportsAPI from '../../api/customReports';

const state = {
  data: {},
  uiFlags: {
    isFetching: false,
  },
};

const getters = {
  getAIAnalyticsData: $state => $state.data,
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetchAIAnalytics({ commit }, { since, until: untilDate }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await CustomReportsAPI.getAIResponseAnalytics({
        since,
        until: untilDate,
        type: 'ALL',
        mode: 'AGGREGATE',
      });
      commit('setData', response.data?.data || {});
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching AI analytics:', error);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
};

const mutations = {
  setData($state, data) {
    $state.data = data;
  },
  setUIFlag($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
